export type DashboardApiTarget = "local" | "staging"
export type DashboardDataMode = "api" | "fixtures"

const requestedTarget = import.meta.env.VITE_DASHBOARD_API_TARGET
const apiTarget: DashboardApiTarget = requestedTarget === "staging" ? "staging" : "local"
const requestedDataMode = import.meta.env.VITE_DASHBOARD_DATA_MODE
const dataMode: DashboardDataMode = requestedDataMode === "fixtures" ? "fixtures" : "api"
const configuredBaseUrl = import.meta.env.VITE_DASHBOARD_API_BASE_URL
const defaultBaseUrl = apiTarget === "staging" ? "https://network.undetect.dev" : ""
const routeBase = normalizeRouteBase(import.meta.env.VITE_DASHBOARD_ROUTE_BASE ?? "/app/")
const fixtureAuthBypass = dataMode === "fixtures" && import.meta.env.MODE !== "test"

export const dashboardEnvironment = {
  apiBaseUrl: normalizeBaseUrl(configuredBaseUrl ?? defaultBaseUrl),
  apiTarget,
  dataMode,
  fixtureAuthBypass,
  fixtureFallback: dataMode === "fixtures",
  routeBase
} as const

function normalizeBaseUrl(value: string): string {
  return value.trim().replace(/\/+$/, "")
}

function normalizeRouteBase(value: string): string {
  const trimmed = value.trim()
  if (!trimmed || trimmed === "/") {
    return "/"
  }

  const withLeadingSlash = trimmed.startsWith("/") ? trimmed : `/${trimmed}`
  return withLeadingSlash.endsWith("/") ? withLeadingSlash : `${withLeadingSlash}/`
}
